/*
 *  I18VENTGAINECalcul.js
 *
 *  Created by Sébastien Hecart on 2018-08-04 11:38:43 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import {
  fetchDnGaineRectangulaireDiametreInferieur,
  fetchDnGaineCirculaireDiametreInferieur,
  fetchPerteChargeUnite,
  fetchDnGaineRectangulaire,
  fetchDnGaineCirculaire,
  fetchDnAround,
  fetchRugositeMaterial
} from '@batical/data/src'
import { RDnGaineRectangulaire_Type, I18VENTGAINE_State } from '@batical/types/src'

import { colebrook } from '../CommonFormula'

function I18VENTGAINE_docalcul(state: I18VENTGAINE_State, isWeb: boolean = false) {
  state.invalidated = false
  let selectedRugosite = fetchRugositeMaterial(state.rugosite_uuid)
  //TODO CALCUL
  state.res_petitcote = 0
  state.res_grandcote = 0
  state.res_dnEquivalent = 0

  const debit = state.in_debitGaine / 3600
  const section = debit / state.in_vitesse
  const diametreTheoriqueCirculaire = Math.sqrt((section * 4) / Math.PI) * 1000
  const pdcUnit = fetchPerteChargeUnite(state.perteCharg_uuid)

  if (state.in_mode_gaine === 0) {
    var gaineSelected = fetchDnGaineRectangulaireDiametreInferieur(diametreTheoriqueCirculaire)

    if (gaineSelected) {
      if (state.selected_tube !== '') {
        const sel: RDnGaineRectangulaire_Type = fetchDnGaineRectangulaire(state.selected_tube)
        state.selected_tube = ''
        if (sel.diam_int === gaineSelected.diam_int) {
          gaineSelected = sel
        }
      }
      state.res_petitcote = gaineSelected.petite_cote
      state.res_grandcote = gaineSelected.grand_cote
      state.res_dnEquivalent = gaineSelected.diam_int
      state.selected_tube = gaineSelected.uuid
      if (isWeb) {
        state.dataChart = fetchDnAround(gaineSelected.uuid)
      }
    }
  } else {
    var gaineCircSelected = fetchDnGaineCirculaireDiametreInferieur(diametreTheoriqueCirculaire)

    if (gaineCircSelected) {
      if (state.selected_tube !== '') {
        const sel = fetchDnGaineCirculaire(state.selected_tube)

        if (sel.diam_int === gaineCircSelected.diam_int) {
          gaineCircSelected = sel
        }
      }
      state.res_dnEquivalent = gaineCircSelected.diam_int
      state.selected_tube = gaineCircSelected.uuid
    }
  }

  if (state.res_dnEquivalent !== 0) {
    state.res_vitesseReel = (4 * debit) / Math.PI / Math.pow(state.res_dnEquivalent / 1000, 2)
    const reynolds = ((state.res_dnEquivalent / 1000) * state.res_vitesseReel) / state.res_viscCine

    let facteurpc = 0.0114919402588942
    if (reynolds < 3000) {
      facteurpc = 64 / reynolds
    } else {
      facteurpc = colebrook(reynolds, selectedRugosite.rugosite, state.res_dnEquivalent)
    }
    state.res_pdcLinaire =
      (((facteurpc / (state.res_dnEquivalent / 1000)) * state.res_masseVolAir) / 2) * Math.pow(state.res_vitesseReel, 2) * pdcUnit.factor
  } else {
    state.res_vitesseReel = 0
  }

  return state
}

export default I18VENTGAINE_docalcul
